import { setCookieWithToken } from 'api/index.js'

export default {
  methods: {
    login(name = 'yixinlizx') {
      let loginClass = require('app/frontend-lib/login/login.js').default(name)
      return loginClass.queryLoginStatus().then(() => {
        const { token } = loginClass.userInfo
        return setCookieWithToken(token)
      })
    }
  }
}
